<template>
    <div class="myCharts" ref="echartsDom"></div>
</template>

<script>
    const echarts = require("echarts");
    export default {
        name: "SingalLine",
        props: {
            dataArr: Array,
            axisArr: Array,
        },
        data() {
            return {
                myChart: null,
                option: {
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: [],
                    },
                    yAxis: {
                        type: "value",
                    },
                    series: [{
                        data: [],
                        type: "line",
                        smooth: true,
                    }, ],
                    grid: {
                        top: '5%',
                        left: '35',
                        right: '5%',
                        bottom: '30',
                    },
                }
            }
        },

        computed: {
            dateRange() {
                const {
                    dataArr,
                    axisArr
                } = this;
                return {
                    dataArr,
                    axisArr
                }
            }
        },

        mounted() {
            let myChart = echarts.init(this.$refs.echartsDom);
            this.myChart = myChart

            this.myChart.setOption(this.option);

            window.addEventListener("resize", () => {
                this.myChart.resize();
            });
        },

        watch: {
            dateRange(n, o) {
           
                this.myChart.clear()
                this.option.series[0].data = n.dataArr
                this.option.xAxis.data = n.axisArr
                if(n.dataArr.length < 1){
                    this.option.yAxis = {
                        type: "category",
                        data: [1,10,100]
                    }
                } else {
                    this.option.yAxis = {
                        type: "value",
                    }
                }
                this.myChart.setOption(this.option);
            },
        },
    };
</script>

<style lang="less" scoped>
    .myCharts {
        width: 100%;
        height: 100%;
    }
</style>